"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Context_1 = require("@twii/core/lib/Context");
var StringUtils_1 = require("@twii/core/lib/StringUtils");
var defaultAdminCheck = function (userProfile) {
    return userProfile && userProfile.user && userProfile.user.groups && userProfile.user.groups.some(function (g) {
        return StringUtils_1.equalsIgnoreCase(g.name, "admin");
    });
};
var UserAdminContext = new Context_1.Context({
    value: defaultAdminCheck
});
exports.UserAdminContext = UserAdminContext;
